<template>
  <v-app>
    <!-- Desktop top bar -->
    <v-app-bar v-if="!isDesignerMobile" app color="white" elevation="1" dense>
      <v-toolbar-title class="font-weight-bold primary--text">
        <v-icon left color="primary">mdi-led-strip-variant</v-icon>
        <span class="d-none d-sm-inline">MQTT 灯控</span>
      </v-toolbar-title>
      <v-spacer />
      <v-btn text to="/" :class="{ 'primary--text': $route.path === '/' }">
        <v-icon left small class="d-none d-sm-inline">mdi-test-tube</v-icon>
        <span>协议测试</span>
      </v-btn>
      <v-btn text to="/designer" :class="{ 'primary--text': $route.path === '/designer' }">
        <v-icon left small class="d-none d-sm-inline">mdi-palette</v-icon>
        <span>设计器</span>
      </v-btn>
    </v-app-bar>

    <router-view />

    <!-- Mobile bottom nav (only for non-designer pages) -->
    <v-bottom-navigation
      v-if="isMobile && !isDesignerMobile"
      app
      v-model="activeTab"
      color="primary"
      grow
    >
      <v-btn to="/">
        <span>协议测试</span>
        <v-icon>mdi-test-tube</v-icon>
      </v-btn>
      <v-btn to="/designer">
        <span>设计器</span>
        <v-icon>mdi-palette</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      activeTab: 0,
      windowWidth: window.innerWidth
    }
  },
  computed: {
    isMobile () {
      return this.windowWidth < 960
    },
    isDesignerMobile () {
      return this.$route.path === '/designer' && this.windowWidth < 960
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
    this.updateTab()
  },
  watch: {
    '$route.path' () {
      this.updateTab()
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.windowWidth = window.innerWidth
    },
    updateTab () {
      if (this.$route.path === '/designer') this.activeTab = 1
      else this.activeTab = 0
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Inter, Roboto, "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Mobile safe area */
.v-bottom-navigation {
  padding-bottom: env(safe-area-inset-bottom) !important;
}
</style>
